module.exports = __webpack_public_path__ + "static/media/SkillsProgrammeUpload_Template.1938c57e.xlsx";